import api from './api'
import axios from 'axios'
import Promise from 'es6-promise'
import { Toast } from 'vant'
Promise.polyfill()
axios.defaults.withCredentials = true

function getContact() {
  return api.contact
}

/**
 * 发起 get 请求
 * @param url
 * @param params
 * @param success
 * @param error
 */
function get(url, params, success, error) {
  axios.get(url, {
    params: params,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization-Str': getLS(api.access_token) ? getLS(api.access_token) : ''
    }
  })
    .then(function (response) {
      let data = response.data
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      if (data.code === 200) {
        success(data.data)
      } else if (data.code === 401) {
        Toast(data.message)
        loginAgain()
      } else if (data.code === 402) {
        Toast(data.message)
        loginAgain()
      } else if (data.code === 403) {
        Toast(data.message)
        loginAgain()
      } else if (data.code === 404) {
        Toast(data.message)
        loginAgain()
      } else if (data.code === 405) {
        Toast(data.message)
        loginAgain()
      } else if (data.code === 406) {
        Toast(data.message)
        setTimeout(function () {
          loginAgain()
        }, 3000)
      } else {
        typeof error === 'function' && error(data.message)
        Toast(data.message)
      }
    })
    .catch(function (err) {
      typeof error === 'function' && error(err)
    })
}

/**
 * gdb2
 * 发起 get 请求
 * @param url
 * @param params
 * @param success
 * @param error
 */
function get1(url, params, success, error) {
  axios.get(url, {
    params: params,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization-Str': getLS(api.access_token) ? getLS(api.access_token) : ''
    }
  })
    .then(function (response) {
      let data = response.data
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      if (data.code === 200 || data.state === 1) {
        success(data.data)
      } else if (data.code === 401) {
        Toast(data.message)
        loginAgain()
      } else if (data.code === 402) {
        Toast(data.message)
        loginAgain()
      } else if (data.code === 403) {
        Toast(data.message)
        loginAgain()
      } else if (data.code === 404) {
        Toast(data.message)
        loginAgain()
      } else if (data.code === 405) {
        Toast(data.message)
        loginAgain()
      } else if (data.code === 406) {
        Toast(data.message)
        setTimeout(function () {
          loginAgain()
        }, 3000)
      } else {
        typeof error === 'function' && error(data.message || data.msg)
        Toast(data.message || data.msg)
      }
    })
    .catch(function (err) {
      typeof error === 'function' && error(err)
    })
}

/**
 * post
 * @param url
 * @param params
 * @param success
 * @param error
 */
function post(url, params, success, error) {
  axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization-Str': getLS(api.access_token) ? getLS(api.access_token) : ''
    }
  }).then(function (response) {
    let data = response.data
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }
    if (data.code === 200 || data.state === 1) {
      success(data.data)
    } else if (data.code === 401) {
      Toast(data.message)
      loginAgain()
    } else if (data.code === 402) {
      Toast(data.message)
      loginAgain()
    } else if (data.code === 403) {
      Toast(data.message)
      loginAgain()
    } else if (data.code === 404) {
      Toast(data.message)
      loginAgain()
    } else if (data.code === 405) {
      Toast(data.message)
      loginAgain()
    } else if (data.code === 406) {
      Toast(data.message)
      setTimeout(function () {
        loginAgain()
      }, 3000)
    } else {
      typeof error === 'function' && error(data || data.message || data.msg)
      Toast(data.message || data.msg)
    }
  })
    .catch(function (err) {
      typeof error === 'function' && error(err)
    })
}

// 20231204 小产品数据获取
function smallGet(url, params, success, error) {
  const headerSign = getLS('headerSign');
  axios.get(url, {
    params: {
      sign: headerSign.sign ? headerSign.sign : '',
      ...params
    },
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization-Str': headerSign.header ? headerSign.header : ''
    }
  })
    .then(function (response) {
      const data = response
      if (data.status === 200) {
        success(data.data)
      } else if (data.status === 401) {
        Toast(data.message)
        loginAgain()
      } else if (data.status === 402) {
        Toast(data.message)
        loginAgain()
      } else if (data.status === 403) {
        Toast(data.message)
        loginAgain()
      } else if (data.status === 404) {
        Toast(data.message)
        loginAgain()
      } else if (data.status === 405) {
        Toast(data.message)
        loginAgain()
      } else if (data.status === 406) {
        Toast(data.message)
        setTimeout(function () {
          loginAgain()
        }, 3000)
      } else {
        typeof error === 'function' && error(data.message)
        Toast(data.message)
      }
    })
    .catch(function (err) {
      typeof error === 'function' && error(err)
    })
}



/**
 * 获取 LocalStorage
 * @param key
 */
function getLS(key) {
  let data = localStorage.getItem(key)
  try {
    return JSON.parse(data)
  } catch (err) {
    return data
  }
}

/**
 * 设置 LocalStorage
 * @param key
 * @param data
 */
function setLS(key, data) {
  if (typeof data === 'object') {
    data = JSON.stringify(data)
  } else if (typeof data === 'number') {
    data = data.toString()
  } else if (typeof data === 'boolean') {
    data = data.toString()
  } else if (typeof data === 'undefined') {
    data = ''
  }
  localStorage.setItem(key, data)
}

/**
 * 登录
 * @param data
 * @param success
 * @param error
 * @returns {boolean}
 */
function login(data, success, error) {
  post(api.login, data, success, error)
}

/**
 * 返回 token
 */
function getAuthCode() {
  return getLS(api.access_token)
}

/**
 * 判断是否登录
 * @param success
 * @param error
 */
function islogin(success, error) {
  get(api.islogin, {}, success, error)
}

/**
 * 重新登录
 */
function loginAgain() {
  window.localStorage.removeItem(api.child)
  window.localStorage.removeItem(api.token)
  window.location.href = '/#/login'
}

export default {
  getContact,
  getLS,
  setLS,
  get,
  get1,
  smallGet,
  post,
  login,
  islogin,
  loginAgain,
  getAuthCode
}



// WEBPACK FOOTER //
// ./src/libs/utils.js